import "./index.css"

const SwitchButton = ({ coluna, colunas }) => {
    return (
        <>
        <div className="wrapperSwitch">
            <label className="switch" htmlFor={`${coluna}`}>
                <input type="checkbox" id={`${coluna}`} defaultChecked={colunas[coluna]} />
                <span className="slider round"></span>
            </label>
            <span>{coluna}</span>
        </div>
        </>
    )
}

export default SwitchButton;